import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/clinical-solutions/medical-device-clinical-trials")({
  head: () => buildRouteHead("/zh-cn/services/clinical-solutions/medical-device-clinical-trials", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/zh-cn/services/full-service-medical-device-cro", replace: true });
  },
});
